import { ContractType } from '../types/contract.type'

export class Contract {
  public constructor(public readonly contractType: ContractType) {}

  public get contractNameAsOption(): string {
    if (this.contractType === 'Two') {
      return $localize`:Contract name as option:Two`
    }

    if (this.contractType === 'Three') {
      return $localize`:Contract name as option:Three`
    }

    if (this.contractType === 'Four') {
      return $localize`:Contract name as option:Four`
    }

    if (this.contractType === 'Five') {
      return $localize`:Contract name as option:Five`
    }

    if (this.contractType === 'Bettler') {
      return $localize`:Contract name as option:Six`
    }

    if (this.contractType === 'NoTrump') {
      return $localize`:Contract name as option:Seven`
    }

    if (this.contractType === 'TwoHand') {
      return $localize`:Contract name as option:Spades`
    }

    if (this.contractType === 'ThreeHand') {
      return $localize`:Contract name as option:Diamonds`
    }

    if (this.contractType === 'FourHand') {
      return $localize`:Contract name as option:Hearts`
    }

    if (this.contractType === 'FiveHand') {
      return $localize`:Contract name as option:Clubs`
    }

    if (this.contractType === 'BettlerHand') {
      return $localize`:Contract name as option:Bettler`
    }

    if (this.contractType === 'NoTrumpHand') {
      return $localize`:Contract name as option:No Trump`
    }

    throw new Error(
      `Unable to get contract name for contract ${this.contractType}`,
    )
  }

  public get contractName(): string {
    if (this.contractType === 'Two') {
      return $localize`:Contract name:Spades`
    }

    if (this.contractType === 'Three') {
      return $localize`:Contract name:Diamonds`
    }

    if (this.contractType === 'Four') {
      return $localize`:Contract name:Hearts`
    }

    if (this.contractType === 'Five') {
      return $localize`:Contract name:Clubs`
    }

    if (this.contractType === 'Bettler') {
      return $localize`:Contract name:Bettler`
    }

    if (this.contractType === 'NoTrump') {
      return $localize`:Contract name:No Trump`
    }

    if (this.contractType === 'TwoHand') {
      return $localize`:Contract name:Spades Hand`
    }

    if (this.contractType === 'ThreeHand') {
      return $localize`:Contract name:Diamonds Hand`
    }

    if (this.contractType === 'FourHand') {
      return $localize`:Contract name:Hearts Hand`
    }

    if (this.contractType === 'FiveHand') {
      return $localize`:Contract name:Clubs Hand`
    }

    if (this.contractType === 'BettlerHand') {
      return $localize`:Contract name:Bettler Hand`
    }

    if (this.contractType === 'NoTrumpHand') {
      return $localize`:Contract name:No Trump Hand`
    }

    throw new Error(
      `Unable to get contract name for contract ${this.contractType}`,
    )
  }
}

export const contractNull: Contract = new Contract('Two')
